import axios from "axios";
import { BaseUrl } from "./baseUrl";
export const httpAxios = axios.create({
//   baseURL: process.env.BASE_URL,
  baseURL: "https://8bb7-2405-201-200c-b1b8-2532-b7f3-2ece-3f6a.ngrok-free.app",
  // baseURL: "http://192.168.29.195:3000",
  // baseURL:process.env.REACT_APP_SERVER_APP 
  
});